import "./ArrowLink.css";
import { Link } from "react-router-dom";
import ScrollAnimation from "../ScrollAnimation/ScrollAnimation";

const ArrowLink = ({ text, link, delay = 0 }) => {
    return (
        <div className="arrow-link">
            <Link to={link}>
                <ScrollAnimation type="revealRight" delay={delay}>
                    <span>
                        <i className="fa-solid fa-arrow-right"></i>
                    </span>{" "}
                </ScrollAnimation>

                <ScrollAnimation delay={delay} className="arrow-link-text">
                    {text}
                </ScrollAnimation>
            </Link>
        </div>
    );
};

export default ArrowLink;
